import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import { verifiedUserLisitingRequest, verifiedUserLisitingUpdateUserStatus, verifiedUserPhone,verifiedUserEmail } from '../../../redux/actionDispatcher/admin/userListingDispatcher';
import { ApiURLs, imageBaseUrls } from '../../../constant/ApiUrls';
import Swal from 'sweetalert2';
import { patchData } from '../../../services/api';
import { NavigationRoutes } from '../../../constant/Routes';
import { useNavigate } from 'react-router-dom';
import dummyProfileImage from "./../../assets/image/dummy-profile-image.png"
import moment from "moment";

import { CheckCircle, XCircle } from "lucide-react";


function UserLisitingTable({ userListing }) {


  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ✅ State for pagination
  const [page, setPage] = useState(0); // Starts from 0
  const [pageSize, setPageSize] = useState(50);
  const [sortModel, setSortModel] = useState([{ field: "created_at", sort: "desc" }]);
  const [searchTerm, setSearchTerm] = useState('');

  const userListingHeading = [

    {
      field: "id", headerName: "NO", width: 40,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (pageSize * page),

    },
    {
      field: "created_at", headerName: "Join Date", width: 100,
      // renderCell: (params) => moment(params.value).format("DD/MM/YYYY HH:mm:ss"), 
      renderCell: (params) => {
        const formattedDate = moment(params.value).format("DD/MM/YYYY");
        const fullDateTime = moment(params.value).format("DD/MM/YYYY HH:mm:ss");
        return (
          <span title={fullDateTime}>
            {formattedDate}
          </span>
        );
      },
      // renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,

    },
    {
      field: "image",
      headerName: "Profile",
      width: 60,
      sortable: false,

      renderCell: (params) => (
        <img
          src={params.value ? `${imageBaseUrls(params.value)}` : dummyProfileImage}
          alt="Profile"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {

      field: "name", headerName: "Name", width: 130
    },
    {
      flex: 2,
      field: "email", headerName: "Email", width: 130,
      //  renderCell: (params) => (
      //   <span style={{ color: params.row.email_verified === 1 ? "green" : "red" }}>
      //     {params.value}
      //   </span>
      // ), 


        renderCell: (params) => {
    const isVerified = params.row.email_verified === 1;
    


    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {params.value.trim() !== "Not Added" &&
          (isVerified ? (
            <CheckCircle  className="icon-fixed" color="green" size={18} />
          ) : (
            <XCircle  className="icon-fixed" color="red" size={18} />
          ))
          }
        <span >{params.value}</span>

      </div>
    );
  },
    },

    
    // {
    //   field: "email_verified", headerName: "Email Status", width: 100,
    //   valueGetter: (value, row) => `${row.email_verified === 1 ? 'Verified' : 'Not Verified'}`,
    //   renderCell: (params) => (
    //     <span style={{ color: params.row.email_verified === 1 ? "green" : "red" }}>
    //       {params.value}
    //     </span>
    //   ),

    // },


    {

      field: "number",
      headerName: "Number",
      flex: 1,
      minWidth: 130,

      maxWidth: 180,
      sortable: false,
      valueGetter: (value, row) => `${row.flag || ''} ${row.number || 'Not Added'}`,
      // renderCell: (params) => (
      //   <span style={{ color: params.row.otp_verified === 1 ? "green" : "red" }}>
          
      //     {params.value==="Not Added"?params.value:`+${params.value}`}
      //   </span>
      // ),
  renderCell: (params) => {
    const isVerified = params.row.otp_verified === 1;
    
    const numberValue =
      params.value.trim() === "Not Added" ? params.value.trim() : `+${params.value}`;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {params.value.trim() !== "Not Added" &&
          (isVerified ? (
            <CheckCircle  className="icon-fixed" color="green" size={18} />
          ) : (
            <XCircle  className="icon-fixed" color="red" size={18} />
          ))
          }
        <span style={
          params.value.trim() === "Not Added"?{color:"red"}:{}
        }>{numberValue}</span>

      </div>
    );
  },
    },


    // {

    //   field: "total_hours_logged",
    //   headerName: "LogIn\nHrs.",
    //   flex: 1,
    //   minWidth: 80,

    //   maxWidth: 80,
    //   sortable: true,
    //   valueGetter: (value, row) => `${row.total_hours_logged || '0'} hrs`,
    //   // renderCell: (params) => params.value




    // },

    {

      field: "ads_count",
      headerName: "Ads Live",
      flex: 1,
      minWidth: 50,

      maxWidth: 80,
      sortable: true,
      // valueGetter: (value, row) => `${'0'}`,
      // renderCell: (params) => params.value




    },
    {
      field: "action",
      headerName: "Action",
      width: 400,
      sortable: false,

      renderCell: (params, row) => (
        <div style={{
          display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
          height: "100%"
        }}>

          {(params.row.otp_verified===0 && params.row.number!=='' &&  params.row.number!==undefined &&  params.row.number!==null)&&(<button
            onClick={() => handleVerifyPhone(params.row)}
            style={{
              backgroundColor: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Verify Phone
          </button>)}



            {(params.row.email_verified===0 )&&(<button
            onClick={() => handleVerifyEmail(params.row)}
            style={{
              backgroundColor: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Verify Email
          </button>)}


          <button
            onClick={() => {
              // console.log("veiw is called")
              navigate(NavigationRoutes.ADMIN_DASHBOARD + NavigationRoutes.USER_DETAILS.replace(":id", `:${params.row.id}`));
            }}
            style={{
              backgroundColor: "rgb(131 131 131)",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            View
          </button>

          <button
            onClick={() => handleBlock(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params.row.status === 1 ? "Block" : "Unblock"}
          </button>

          <button
            onClick={() => handleChangeEmail(params.row)}
            style={{
              backgroundColor: "#448EE4",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Change Email
          </button>



          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            { "Delete"}
          </button>
        </div>

      ),
    },
  ];

  const handleBlock = (row) => {
    console.log("Deleting User ID:", row);
    Swal.fire({
      title: `${row.status === 1 ? "Block" : "Unblock"}`,
      html:
        "<hr>" +
        "Are you sure?" +
        "<br>" +
        `You want to  ${row.status === 1 ? "block" : "unblock"
        } ${row.name}`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `${row.status === 1 ? "Block" : "Unblock"}`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(verifiedUserLisitingUpdateUserStatus({ userId: row.id, status: row.status === 1 ? 0 : 1 }));
        var response = await patchData(`${ApiURLs.GET_USERS}/${row.id}`);
        if (response.status !== 1) {

          dispatch(verifiedUserLisitingUpdateUserStatus({ userId: row.id, status: row.status === 1 ? 0 : 1 }));
        }
      }
    });

    // Add your delete logic here
  };




    const handleDelete = (row) => {
    console.log("Deleting User ID:", row);
    Swal.fire({
      title: `Delete`,
      html:
        "<hr>" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete ${row.name}`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
          try {
  const sortField = sortModel[0]?.field || "created_at";
  const sortOrder = sortModel[0]?.sort || "desc";

  // Call delete API
  const response = await patchData(`${ApiURLs.DELETE_USER}/${row.id}`);
  console.log("STATTUSSSS::::::::", response);

  if (response.status === 1) {
    dispatch(
      verifiedUserLisitingRequest(sortField, sortOrder, 1, pageSize, searchTerm)
    );
  }
} catch (error) {
  console.error("Error while deleting user:", error);

  // Optionally show error to user
  // toast.error("Failed to delete user. Please try again later.");

  // Refresh listing anyway to keep UI consistent
 
}

      }
    });

    // Add your delete logic here
  };




    const handleVerifyPhone = (row) => {
    // console.log("Deleting User ID:", row);
    Swal.fire({
      // title: `${"Verify Phone Confirmation"}`,
      html:
        
        "Are you sure?" +
        "<br>" +
        `You want to verify phone number  <b>+${row.flag} ${row.number}</b> of <b>${row.name}</b>`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Verify`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(verifiedUserPhone({ userId: row.id, otp_verified:1 }));
        var response = await patchData(`${ApiURLs.USER_UPDATE}/${row.id}`, {otp_verified:1});
        if (response.status !== 1) {

          dispatch(verifiedUserPhone({ userId: row.id, otp_verified:1 }));
        }
      }
    });

    // Add your delete logic here
  };



     const handleVerifyEmail = (row) => {
    // console.log("Deleting User ID:", row);
    Swal.fire({
      // title: `${"Verify Phone Confirmation"}`,
      html:
        
        "Are you sure?" +
        "<br>" +
        `You want to verify email <b>${row.email}</b> of <b>${row.name}</b>`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Verify`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(verifiedUserEmail({ userId: row.id, email_verified:1 }));
        var response = await patchData(`${ApiURLs.USER_UPDATE}/${row.id}`, {email_verified:1});
        if (response.status !== 1) {

          dispatch(verifiedUserEmail({ userId: row.id, email_verified:1 }));
        }
      }
    });

    // Add your delete logic here
  };

  const handleChangeEmail = (row) => {
    Swal.fire({
      title: 'Change Email',
      html: `
      <p style="margin-bottom: 10px;">Current Email: <strong>${row.email}</strong></p>
      <input id="swal-input-email" class="swal2-input" type="email" placeholder="Enter new email" />
    `,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Update Email',
      showCloseButton: true,
      cancelButtonColor: 'gray',
      confirmButtonColor: '#4f83df',
      reverseButtons: true,
      preConfirm: () => {
        const email = document.getElementById('swal-input-email').value.trim();
        if (!email) {
          Swal.showValidationMessage('Email is required');
          return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          Swal.showValidationMessage('Invalid email format');
          return false;
        }
        return { email };
      }
    }).then(async (result) => {
      console.log('Updating email to:', result);
      if (result.isConfirmed) {
        const updatedEmail = result.value.email;
        console.log('Updating email to:', updatedEmail);
        try {
          var response = await patchData(`${ApiURLs.EMAIL_UPDATE}/${row.id}`, { email: updatedEmail });
          console.log("response change amail", response);
          if (response.status === 1) {
            const sortField = sortModel[0]?.field || "created_at";
            const sortOrder = sortModel[0]?.sort || "desc";
            dispatch(verifiedUserLisitingRequest(sortField, sortOrder, page + 1, pageSize));
            Swal.fire('Success', `Email has been updated to ${updatedEmail}`, 'success');
          }
        }
        catch (e) {
          console.log("error changing email", e);
        }

        // 🔁 Example API/Redux call
        // await dispatch(updateUserEmail({ userId: row.id, email: updatedEmail }));
      }
    });
  };

  React.useEffect(() => {
    const sortField = sortModel[0]?.field || "created_at";
    const sortOrder = sortModel[0]?.sort || "desc";
    dispatch(verifiedUserLisitingRequest(sortField, sortOrder, page + 1, pageSize,searchTerm));
  }, [sortModel, page, pageSize,searchTerm, dispatch]);

  return (

    <Paper sx={{ height: "95%", width: '100%' }}>


      <div style={{
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <input
          type="text"
          placeholder="Search by Name, Email, Number"
          value={searchTerm}
          onChange={(e) => {
            setPage(0);
            setSearchTerm(e.target.value);
          }}
          style={{
            padding: "6px 10px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "50%"
          }}
        />
        </div>

        <DataGrid
          rows={userListing.usersListing || []}
          columns={userListingHeading || []}
          rowCount={userListing.totalUsers || 0} // ✅ Total count from Redux
          paginationMode="server" // ✅ Enable manual pagination
          sortingMode="server"
          page={page}
          pageSize={pageSize}
          sortModel={sortModel}
          onSortModelChange={(model) => setSortModel(model)}
          pageSizeOptions={[10, 25, 50]}
          loading={userListing.loading}
          checkboxSelection={false}
          sx={{ border: 0 }}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => {
            setPage(model.page);
            setPageSize(model.pageSize);
          }}


        />
    </Paper>
  );
}

//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    userListing: state.userListing,
  };
};

//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    verifiedUserLisiting: (data, navigate) => dispatch(verifiedUserLisitingRequest(data, navigate)),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(UserLisitingTable);
